import type { InitiativeStatus } from 'api/initiatives/types';
import { INITIATIVE_STATUS_LABELS } from '../components/initiatives-table/consts';

export const STATUS_OPTIONS = (
    Object.entries(INITIATIVE_STATUS_LABELS) as [InitiativeStatus, string][]
).filter(([value]) => value !== 'ON_HOLD')
    .map(([value, label]) => ({ value, label }));
